export const word = {
  en: {
    resName: "Restaurant Name",
    resAddress: "Address",
    description: "Description",
    chooseLanguages: "Choose Language",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    menu: "Menu",
    categoryName: "Category Name",
    title: "Title",
    price: "Price",
    priceUnit: "Price Unit",
    language: "Language",
    profile: "Profile",
    search: "Search",
    searchResult: "Search Result: ",
    noDescription: "no description",
    order: "Order",
    notFound: "Not Found",
    orderSuccess: "Order Successfully Registered. Thanks For Choosing Us 🤩",
    orderError: "we've some issue for registering your order!",
    orderError406:
      "One or more items in the order have been changed by the restaurant. Please press the Update Cart button.",
    checkout: "Checkout",
    back: "Back",
    shoppingCard: "Shopping Card",
    finalOrderText: "Finilize your order",
    totalPrice: "Total Price",
    notActive: "Not Active",
    userLogin: "User Login",
    userLoginText: "Please enter your mobile number",
    mobileNumber: "Mobile Number ex:09123456789",
    notValidMobileNumber: "Mobile number is not valid",
    verificationCode: "Verification Code",
    verificationCodeSubtitle:
      "Enter the 5 digit code we send you via text to continue",
    code: "Code",
    resendCode: "Resend Code",
    changeNumber: "Change Number",
    verifyError: "Please enter the code",
    verifyNotCorrect: "Code is incorrect",
    account: "Account",
    accountText: "Complete your information",
    orderHistoryText: "See your last orders",
    fullName: "Full Name",
    email: "E-mail",
    information: "Information",
    ordersHistory: "Orders History",
    emailError: "E-mail format is incorrect",
    logout: "Logout",
    chooseLanguage: "Choose Language",
    total: "Total",
    tax: "Tax",
    services: "Services",
    packing: "Packing",
    discount: "Discount",
    facture: "Facture",
    facNumber: "Facture No.:",
    reorder: "Reorder",
    viewInvoice: "View the invoice",
    active: "Active",
    deactive: "Deactive",
    credit: "Credit",
    updateShoppingCard: "Update Card",
    paymentError: "There was a problem with the payment",
  },
  fa: {
    resName: "نام رستوران",
    resAddress: "آدرس",
    description: "توضیحات",
    chooseLanguages: "انتخاب زبان",
    cancel: "انصراف",
    confirm: "تایید",
    save: "ذخیره",
    menu: "منو",
    categoryName: "نام دسته",
    title: "عنوان",
    price: "قیمت",
    priceUnit: "واحد پول",
    language: "زبان",
    profile: "اطلاعات کاربری",
    search: "جستجو",
    searchResult: "نتیجه جستجو: ",
    noDescription: "بدون توضیح",
    order: "سفارش",
    notFound: "موردی یافت شد",
    orderSuccess: "سفارش با موفقیت ثبت شد. سپاس از انتخاب شما 🤩",
    orderError: "ثبت سفارش با مشکل مواجه شد!",
    orderError406:
      "یک یا چند مورد از آیتم های سفارش توسط رستوران تغییر وضعیت داده شده است. لطفا دکمه بروزرسانی سبد خرید را فشار دهید.",
    checkout: "ثبت سفارش",
    back: "بازگشت",
    shoppingCard: "سبد خرید",
    finalOrderText: "خرید خود را نهایی کنید",
    totalPrice: "مبلغ قابل پرداخت",
    notActive: "غیرفعال",
    userLogin: "ورود کاربر",
    userLoginText: "لطفاً شماره تلفن همراه خود را وارد کنید",
    mobileNumber: "تلفن همراه - مثال:09123456789",
    notValidMobileNumber: "شماره تلفن همراه وارد شده معتبر نیست",
    verificationCode: "کد احراز هویت",
    verificationCodeSubtitle: "برای ادامه کد 5 رقمی ارسال شده را وارد کنید",
    code: "کد",
    resendCode: "ارسال مجدد",
    changeNumber: "تغییر شماره",
    verifyError: "لطفاً کد را وارد کنید",
    verifyNotCorrect: "کد اشتباه است",
    account: "حساب کاربری",
    accountText: "اطلاعات کاربری خود را تکمیل کنید",
    orderHistoryText: "مشاهده سفارش‌های آخر انجام شده",
    fullName: "نام کامل",
    email: "پست الکترونیک",
    information: "اطلاعات",
    ordersHistory: "سفارش های پیشین",
    emailError: "ایمیل وارد شده نا معتبر است",
    logout: "خروج از حساب",
    chooseLanguage: "انتخاب زبان",
    total: "جمع",
    tax: "مالیات",
    services: "حق سرویس",
    packing: "بسته‌بندی",
    discount: "تخفیف",
    facture: "فاکتور",
    facNumber: "شماره فاکتور:",
    reorder: "سفارش مجدد",
    viewInvoice: "مشاهده فاکتور",
    active: "فعال",
    deactive: "غیرفعال",
    credit: "اعتبار",
    updateShoppingCard: "بروزرسانی سبد خرید",
    paymentError: "پرداخت با مشکل مواجه شد",
  },
};
